import { platform } from '../../node_modules/@imp/package/lib/utils'
import { getQueryofKey, getQueryString } from '../../utils/getUrlParams'
import urlExt from '../../node_modules/@imp/package/lib/zyb-yike-utils/urlExt'
// 端外微信授权默认公众号
const appid: string = 'wxfca3b2d43c37ba78'
// 端外微信授权默认产品线ID
const productAppid: number = 375
// 端外GX业务线的默认产品线ID
const gxProductAppid: number = 427
// 获取当前链接上的所有参数
const urlParams: any = getQueryString()
console.log('当前链接上的所有参数为：', urlParams)

// 端外 微信环境下微信授权
export async function wxAuthorize() {
  if (platform.isWechat) {
    // 微信环境下执行相关逻辑
    console.log('当前位于微信环境')
    // 进行第一次授权判断
    const firstAuthRes: any = await checkWxAuth()
    if (!firstAuthRes) {
      // 当前APPID未授权，去授权
      goAuth()
    }
    const urlAppId: any = getQueryofKey('appId') || getQueryofKey('appid')
    if (urlAppId) {
      // 链接上存在appId，可能是公众号投放场景，需要进行二次授权
      // 判断当前appId是否已经授权过
      const secondAuthRes: any = await checkWxAuth(urlAppId)
      if (!secondAuthRes) {
        goAuth(urlAppId)
      }
    }
  }
}

// 检查当前APPID是否已经授权
async function checkWxAuth(appId?: any) {
  const APPID = appId || appid
  const res: any = await (<any>window).$axios.get(
    `/qudao/api/getwxauthstatus`,
    {
      params: {
        appid: APPID,
      },
    }
  )
  console.log(`APPID: ${APPID}授权检测结果：`, res.data)
  const responseData: any = res.data
  if (responseData.errNo !== 0) {
    return false
  }
  if (responseData.data.isOpenid && Number(responseData.data.isOpenid === 1)) {
    return responseData.data.openId
  } else {
    return false
  }
}

// 微信授权跳转
async function goAuth(appId?: any) {
  const APPID = appId || appid
  let rand: string = '' + new Date().getTime() + '' + Math.random().toFixed(3)
  let redirectUri: string = window.location.origin + window.location.pathname
  let referUrl: string = getQueryofKey('refer')
  const urlExtendParam: any = {
    hadAuthorize: 1,
  }
  if (referUrl) {
    referUrl = encodeURIComponent(urlExt.getQuery('refer'))
    urlExtendParam.refer = referUrl
  }
  redirectUri = `${redirectUri}?${urlExt.setQuery(
    urlExtendParam,
    window.location.href
  )}`
  redirectUri = encodeURIComponent(encodeURIComponent(redirectUri))
  // 端外场景没有马甲域名，直接去跳转授权
  window.location.replace(
    `https://tf.zuoyebang.com/wxserver/wechat/authorizev2/product_appid/${productAppid}/rand/${rand}/appid/${APPID}/scope/snsapi_base?redirect_uri=${redirectUri}`
  )
}
